import { InstallationTypes, SensorTypes, SpeedSensorClassification, Roles, PermissionCode } from './enums';
import { MeterReadingGradePeriod } from '@app/shared/models/meter-data/municipality-meter';
import { ConsumptionWizardFilters } from './models/meter/consumption-wizard-filters';

// Local interface to avoid importing from sensordaten module (prevents bundle bloat)
interface ISpeedLimit {
  value: number;
  isDefault: boolean;
}

export const Strings = {
  unassignedRegion: 'Unassigned',
  unbekannt: 'Unbekannt',
  poHoldingRegionid: '45c47ea0-bd41-4b2a-ba55-5a42ab18db8b',
  emailRegex:
    /^(([^<>()\[\]\\.,;:\s@ÄÖÜẞäöüß"]+(\.[^<>()\[\]\\.,;:\s@ÄÖÜẞäöüß"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  mobileRegex: '^[0-9]*/*(\\+\\s*49)*[ ]*(\\([0-9]+\\))*([ ]*(-|–)*[ ]*[0-9]+)*$',
  urlRegex: /^(https?|ftp):\/\/[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/gi,
};

export const Configs = {
  EnergiePortal: 'C_EP',
};

export const Recommendation = [
  {
    type: 'Economical',
    id: '9985B9C8-E566-46F8-B4A1-33A2EA703D0F',
  },
  {
    type: 'Sustainable',
    id: '51A9ADAB-2660-4A61-8AE4-D3AE0D5F86C4',
  },
  {
    type: 'Renovation',
    id: '3BDA5BC9-F616-440D-8B86-531A25C81E46',
  },
  {
    type: 'Manual',
    id: 'CC304A34-0FB0-48F9-B297-31F826C4A180',
  },
];

export const MY_DSO = {
  SUPPORTED_MIME_TYPES: {
    PREVIEW_IMAGE: ['image/jpeg', 'image/png'],
    ATTACHMENT: ['image/jpeg', 'image/png', 'application/pdf', 'text/calendar'],
  },
  MAX_FILE_SIZE: 10 * 1024 * 1024,
};

export const GERMAN_LOCALE = 'de';

export const GERMAN_LOCALE_NAME = 'Deutsch';

export const GERMAN_DATE_FORMAT = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};

export const FEATURE_FUNCTION = {
  page: 'PAGE',
  tab: 'TAB',
};

export enum ModalTransaction {
  CREATE,
  EDIT,
  DELETE,
}

export const METER_CSCN_HTTP_ERROR_CODES = [500, 502, 503, 504];

export const METER_BATCH_SIZE = {
  Meters: 25,
  Readings: 20,
};

export const METER_INTERIM_LOCKREASONS = ['METER_LOCKED', 'OBIS_NOT_RELE'];

export const METER_GRACE_PERIOD: {
  Mandatory: MeterReadingGradePeriod;
  NotMandatory: MeterReadingGradePeriod;
  BiDirectionalReading: MeterReadingGradePeriod;
} = {
  Mandatory: {
    Amount: 23,
    Unit: 'days',
  },
  NotMandatory: {
    Amount: 23,
    Unit: 'days',
  },
  BiDirectionalReading: {
    Amount: 23,
    Unit: 'days',
    DaysLocked: 1,
    QuarterMonth: 3,
    QuarterDay: 31,
  },
};

export const METER_READING = {
  MaxLength: 17,
  MaxDecimal: 14,
};

export const CustomerReadReadingGrouping = ['K', 'C'];

export const SKELETON_LOADER = {
  rows: 7,
};

export const DotDateFormat = 'YYYY.MM.DD';
export const DotDayMonthYearFormat = 'DD.MM.YYYY';
export const ExtendedDateFormat = 'YYYY-MM-DD';
export const CompactDateTimeFormat = 'YYYYMMDDHHmmss';
export const CompactDateTimeFormatWithoutSeconds = 'YYYYMMDDHHmm';
export const ISODateTimeFormat = 'YYYY-MM-DDTHH:mm:ss';
export const ISODateTimeWithZeroSecondsFormat = 'YYYY-MM-DDTHH:mm:00';
export const ISODateTimeStartOfDayFormat = 'YYYY-MM-DDT00:00:00';
export const ISODateTimeLastSecondOfDayFormat = 'YYYY-MM-DDT23:59:59';
export const TwentyFourHourFormat = 'HH:mm:ss';

export const NUMBER_FORMAT = {
  DECIMAL_PLACES: 2,
};

export const externalSockets = [
  '5200 iaw-netz',
  '5201 iaw-netz/lw-k',
  '6100 obag-l-n',
  '6200 qbag-netz',
  '6300 obag-alt',
  '6301 obag-alt/lw',
  '7100 evo-i',
  '7300 evo-ku',
  '8000 üwu-einzelauswechslung',
  '8100 üwu-einzelausw./2x durchf',
  '8200 üwu-netz',
  '8300 üwu-contracting',
  '9999 keine',
  'kooperation',
  'netzpaket',
  'turnuspaket',
  'netzpaket_',
  'wp2 leuchte/netz ohne rei.',
  'wp netz 06',
  'wp netz 08',
  'wp3 sonderleuchten',
  'turnuspaket 06',
  'turnuspaket 08',
  'turnuspaket 08 led',
  'indivi. verträge für kommunen',
  'ottobrunn',
  'sonderleuchten ottobrunn',
  'haar',
  'putzbrunn',
  'turnuspaket ohne lm-wechsel',
  'murnau',
  'speziallampen',
];

export const mechanicalServicePackages = ['ZV15', '1000 basispaket', '1001 basis/sammel', 'basispaket', 'basispaket 06', 'basispaket/sammel'];

export const electricalServicePackages = [
  'ZV7',
  'ZV11',
  '5201 iaw-netz/lw-k',
  '6001 obag-l-n-nr/lw',
  'wp1 leuchte/netz + wp4 lm-we.',
  'komplettpaket n',
  'komplettpaket 08 n',
  'komplettpaket 08 n led',
  'speziallampen',
];

export const fullServicePackages = [
  '1100 komplettpaket',
  '1200 komfortpaket',
  '7000 evo-thüga-spezial',
  'komplettpaket 06',
  'komplettpaket 08',
  'komplettpaket 08 led',
  'komplettpaket',
  'komplett grafenwöhr',
  'komplett grafenwöhr led',
  'komplett abensberg',
  'komplett abensberg led',
  'komplett planegg',
  'komplett grünwald',
  'komplett grünwald led',
  'schwandorf stadt-gebiet',
  'schwandorf obag-gebiet',
  'ruhpolding',
  'unterhaltskosten thüga',
  'komfortpaket 06',
  'komfortpaket',
  'komfortpaket - obag',
  'haar',
  'putzbrunn',
  'murnau',
  'ottobrunn',
  'standardpaket',
  'wahlpaket',
  '5000 iaw-standard',
  '5100 iaw-wahlpaket',
];

export const additionalFullServicePackages = ['ZV18'];

export const electricalDefectTypes = ['Lampe ausgefallen', 'Leuchte erneut gemeldet', 'Leuchte setzt immer wieder aus'];

export const mechanicalDefectTypes = ['Leuchtstelle beschädigt', 'Glas defekt', 'Glas/Wanne', 'Leuchtendach', 'Masttüre', 'mehrere Leuchten ausgefallen'];

export const newElectricalDefectTypes = ['Leuchte funktioniert nicht', 'Mehrere Leuchten ausgefallen'];

export const newMechanicalDefectTypes = ['Mast beschädigt', 'Masttüre fehlt', 'Glas/Wanne beschädigt', 'Leuchtendach beschädigt', 'Leuchtenkopf beschädigt'];

export const damageReport = {
  allowedMimeTypes: ['image/jpeg', 'image/jpg', 'image/png', 'image/bmp', 'application/pdf'],
  allowedFileTypes: ['image', 'pdf'],
};

export const dialogWidth = {
  small: '300px',
  medium: '700px',
  large: '1000px',
};

export const stackedChartSensorTypes = [SensorTypes.SPEED];

export const stackedChartSensorClassifications = [SpeedSensorClassification.DIRECTION, SpeedSensorClassification.SPEED_LIMIT];

export const speedSensorDetailCategories = [SpeedSensorClassification.SPEED_LIMIT, SpeedSensorClassification.DIRECTION, SpeedSensorClassification.CAR_SIZE];

export const nonDecimalSensorTypes = [SensorTypes.MOTION, SensorTypes.SPEED].map((s) => `${s}`);

export const hourlyReadingSensorTypes = [SensorTypes.GAS, SensorTypes.HEAT, SensorTypes.WATER, SensorTypes.SPEED, SensorTypes.ELECTRICITY].map((s) => `${s}`);

export const fifteenminuteReadingSensorTypes = [
  SensorTypes.TEMPERATURE,
  SensorTypes.MOTION,
  SensorTypes.CARBONDIOXIDE,
  SensorTypes.CARBONMONOXIDE,
  SensorTypes.PARTICULATE,
  SensorTypes.AIRQUALITY,
  SensorTypes.FLUID,
  SensorTypes.SMOKE,
  SensorTypes.DOOR,
  SensorTypes.LIGHT,
  SensorTypes.PUSH,
  SensorTypes.GPS,
  SensorTypes.ELECTRICITY,
  SensorTypes.DOGTOILET,
  SensorTypes.SOILMOISTURE,
].map((s) => `${s}`);

export const meterBasedSensors = [
  SensorTypes.GAS,
  // SensorTypes.HEAT,
  // SensorTypes.WATER,
  SensorTypes.ELECTRICITY,
].map((s) => `${s}`);

export const excludedSensors = [SensorTypes.LIGHT].map((s) => `${s}`);

export const PrimarySensorTypes = [SensorTypes.CARBONDIOXIDE, SensorTypes.TEMPERATURE, SensorTypes.SPEED];

export const meterBasedSensorNames = ['Strom', 'Gas', 'Wärme', 'Wasser'];

export const spanNames = ['FIFTEEN_MIN', 'HOURLY', 'DAILY', 'MONTHLY', 'YEARLY'];

export const meterMandatoryHeadlineForFirstReadingOrder = [
  'meterreading.headline.reason_01',
  'meterreading.headline.reason_03',
  'meterreading.headline.reason_09',
];

export const mandatoryHeadlineReason01 = ['meterreading.headline.reason_01'];

export const mandatoryHeadlineReason03And09 = ['meterreading.headline.reason_03', 'meterreading.headline.reason_09'];

export const mandatoryHeadlineReason03 = ['meterreading.headline.reason_03'];

export const mandatoryHeadlineReason09 = ['meterreading.headline.reason_09'];

export const videoFileTypes = ['mp4', 'wmv', 'x-ms-wmv', 'avi'];

export const defaultSpeedLimit: ISpeedLimit = {
  value: 50,
  isDefault: true,
};

export const defaultSensorTypeIcon = 'ico_defaultsensor.svg';

export const wholeDayAlarmRuleIds = ['C1.1', 'C1.2', 'C3.1', 'C3.2', 'C3.3', 'C3.4'];

export const gmsbOperators = [
  '9905766000008',
  '9800171300003',
  '9906532000008',
  '9800199600005',
  '9904980000000',
  '9800135200009',
  '9800191100003',
  '4042805000706',
  'null',
];

export const wmsbOperators = ['9978744000001', '9978721000008', '9978705000008', '4042805002304'];

export const consumerKomKeys = ['KO1', 'KO2', 'KO20', 'KO21', 'KO3', 'KO4', 'KO5', 'KO6', 'KO7', 'KO8', 'KO9', 'KO10'];

export const producerKomKeys = ['KO30', 'KO31', 'KO32', 'KO34'];

export const consumerObisIds = ['1.8.0', '1.8.1', '1.8.2'];

export const producerObisIds = ['2.8.0', '2.8.1', '2.8.2'];

export const hatchedObisIds = ['1.29.0', '7-10:99.33.17', '2.29.0'];

export const municipalityDetails = ['AGS (Amtlicher Gemeindeschlüssel)', 'Gemeindename', 'PLZ', 'Gemeindeverband', 'IstDeaktiviert', 'Primärer KAM', 'Region'];

export const komKeyPairs = {
  producers: ['KO34'],
  consumers: ['KO1', 'KO2', 'KO3', 'KO4'],
};

export const consumptionWizardFilters: ConsumptionWizardFilters[] = [
  {
    timePeriod: 'Periodic',
    meterType: 'MT_SLP',
    hasDeviceEui: false,
  },
  /*
    There are no Gas smart meters, only Electricity
  */
  {
    timePeriod: 'Yearly',
    meterType: 'MT_SMD',
    energyTypesName: 'Strom',
  },
  {
    timePeriod: 'Yearly',
    meterType: 'MT_RLM',
  },
  {
    timePeriod: 'Yearly',
    meterType: 'MT_SLP',
  },
  /*
    There are no Gas smart meters, only Electricity
  */
  {
    timePeriod: 'Monthly',
    meterType: 'MT_SMD',
    energyTypesName: 'Strom',
  },
  {
    timePeriod: 'Monthly',
    meterType: 'MT_RLM',
  },
  {
    timePeriod: 'Monthly',
    meterType: 'MT_SLP',
    hasDeviceEui: true,
  },
  /*
    There are no Gas smart meters, only Electricity
  */
  {
    timePeriod: 'Weekly',
    meterType: 'MT_SMD',
    energyTypesName: 'Strom',
  },
  {
    timePeriod: 'Weekly',
    meterType: 'MT_RLM',
  },
  {
    timePeriod: 'Weekly',
    meterType: 'MT_SLP',
    hasDeviceEui: true,
  },
  /*
    There are no Gas smart meters, only Electricity
  */
  {
    timePeriod: 'Daily',
    meterType: 'MT_SMD',
    energyTypesName: 'Strom',
  },
  {
    timePeriod: 'Daily',
    meterType: 'MT_RLM',
  },
  {
    timePeriod: 'Daily',
    meterType: 'MT_SLP',
    hasDeviceEui: true,
  },
  /*
    There are no Gas smart meters, only Electricity
  */
  {
    timePeriod: 'Hourly',
    meterType: 'MT_SMD',
    energyTypesName: 'Strom',
  },
  {
    timePeriod: 'Hourly',
    meterType: 'MT_RLM',
  },
  {
    timePeriod: 'Hourly',
    meterType: 'MT_SLP',
    hasDeviceEui: true,
  },
  /*
    There are no Gas smart meters, only Electricity
  */
  {
    timePeriod: 'FifteenMinute',
    meterType: 'MT_SMD',
    energyTypesName: 'Strom',
  },
  /*
    EP does not visualize 15-min consumption of Gas RLM meters, only Electricity
  */
  {
    timePeriod: 'FifteenMinute',
    meterType: 'MT_RLM',
    energyTypesName: 'Strom',
  },
  {
    timePeriod: 'FifteenMinute',
    meterType: 'MT_SLP',
    hasDeviceEui: true,
  },
];

export const RolesWithAllMunicipalitiesVisible = [Roles.systemAdministrator, Roles.poDSO, Roles.callCenterAgent, Roles.meterPointExpert];

export const RolesWithRegionMunicipalitiesAssignment = [
  Roles.keyAccountManager,
  Roles.regionalStreetlightExpert,
  Roles.administrationAreaWorker,
  Roles.poHolding,
  Roles.backOffice,
];

// Update list to add tenants that will be using fourth footer link
export const tenantWithFourthFooterLinkLists = ['swg', 'envm'];

export const TENANT_FULLNAME: Record<string, string> = {
  AVA: 'Avacon Netz GmbH',
  BAG: 'Bayernwerk Netz GmbH',
  EDIS: 'E.DIS Netz GmbH',
  ELB: 'ElbEnergie GmbH',
  ENVM: 'Mitteldeutsche Netzgesellschaft Strom mbH',
  LEW: 'LEW Verteilnetz GmbH',
  SHN: 'Schleswig-Holstein Netz GmbH',
  SWG: 'Syna GmbH',
  WEE: 'Westnetz GmbH',
};

export function getTenantFullName(tenantCode: string): string {
  const tenant = tenantCode.trim().toUpperCase();
  return TENANT_FULLNAME[tenant] || tenant;
}

// E-mail content constants
enum EmailTemplates {
  scenarioPlannerCreated = 1,
  inquiryCreated = 3,
  damageReport = 10,
  workOrderCreated = 12,
  notInsuredWorkOrderCreated = 13,
  userDataUpdated = 19,
  requestRegistrationSuccessKam = 20,
  requestRegistrationSuccessUser = 21,
  internalUserInvitation = 30,
  externalUserInvitation = 32,
  externalUserAccountDeletion = 39,
  heatActivationRequest = 40,
  nScaleUploadError = 41,
  heatActivatedEmailNotification = 42,
  workOrderCreationFailed = 43,
  grantedPriviledgedAccess = 45,
}

interface EmailContent {
  subject?: string;
  templateId: number;
  subjectFunc?(...args: unknown[]): string;
}

export const EmailContents: { [key: string]: EmailContent } = {
  ScenarioPlannerCreated: {
    subject: 'Straßenbeleuchtungsplaner',
    templateId: EmailTemplates.scenarioPlannerCreated,
  },
  InquiryCreated: {
    subjectFunc(name: string): string {
      return `Kontaktanfrage: ${name}`;
    },
    templateId: EmailTemplates.inquiryCreated,
  },
  DamageReport: {
    subject: 'Neue Straßenbeleuchtungs-Schadensmeldung via Service-App im EnergiePortal',
    templateId: EmailTemplates.damageReport,
  },
  WorkOrderCreated: {
    subjectFunc(customerCenter: string, workOrderDate: string): string {
      return `Neue Schadensmeldung an das Netzcenter ${customerCenter} vom ${workOrderDate}`;
    },
    templateId: EmailTemplates.workOrderCreated,
  },
  NotInsuredWorkOrderCreated: {
    subject: 'Defekte Leuchtstelle nicht Bestandteil des Wartungspakets',
    templateId: EmailTemplates.notInsuredWorkOrderCreated,
  },
  NScaleUploadError: {
    subjectFunc(municipalityName: string, customerCenter: number, uploadDate: string): string {
      return `NScale nicht erreichbar - ${municipalityName}: Neues Dokument zu einer Schadensmeldung an das Kundencenter ${customerCenter} vom ${uploadDate}`;
    },
    templateId: EmailTemplates.nScaleUploadError,
  },
  UserDataUpdated: {
    subjectFunc(typeChanged: string): string {
      return `EnergiePortal - Neue ${typeChanged}`;
    },
    templateId: EmailTemplates.userDataUpdated,
  },
  RequestRegistrationSuccessKam: {
    subject: 'E-Mail zur Registrierungsanfrage',
    templateId: EmailTemplates.requestRegistrationSuccessKam,
  },
  RequestRegistrationSuccessUser: {
    subject: 'E-Mail zur Registrierungsanfrage',
    templateId: EmailTemplates.requestRegistrationSuccessUser,
  },
  InternalUserInvitation: {
    templateId: EmailTemplates.internalUserInvitation,
  },
  ExternalUserInvitation: {
    templateId: EmailTemplates.externalUserInvitation,
  },
  ExternalUserAccountDeletion: {
    templateId: EmailTemplates.externalUserAccountDeletion,
  },
  HeatActivationRequest: {
    templateId: EmailTemplates.heatActivationRequest,
  },
  HeatActivatedEmailNotification: {
    templateId: EmailTemplates.heatActivatedEmailNotification,
  },
  WorkOrderCreationFailed: {
    subjectFunc(zipCode: string, municipalityName: string, customerCenter: number, workOrderDate: string): string {
      return `EAM nicht erreichbar - ${zipCode} ${municipalityName}: Neue Schadensmeldung an das Kundencenter ${customerCenter} vom ${workOrderDate}`;
    },
    templateId: EmailTemplates.workOrderCreationFailed,
  },
  GrantedPriviledgedAccess: {
    subject: 'EnergiePortal - Genehmigung des privilegierten Zugriffs',
    templateId: EmailTemplates.grantedPriviledgedAccess,
  },
};

export const MeterConsumption: Record<string, Record<string, string>> = {
  Obis: {
    Gas: '7-GAS',
    GasSmd: '7-17:3.1.0',
    GasPreliminary: '7-10:99.33.17',
    GasInvoicing: '7-20:99.33.17',
    GasYearlyFinal: '7-0:33.86.0',
  },
  NonBillingRelevantObis: {
    consumer: '1.29.0',
    producer: '2.29.0',
  },
  MeterClassification: {
    consumer: 'consumer',
    producer: 'producer',
  },
};

export const RlmInstallationTypesCategories = {
  Consumer: [InstallationTypes.Z24],
  Producer: [InstallationTypes.Z01, InstallationTypes.Z02],
};

// export const EnergyDataOverviewList: EnergyDataOverview[] = [
//   { title: 'module.energyData.electricityConsumption' },
//   { title: 'module.energyData.electricityConsumers' },
//   { title: 'module.energyData.electricityProduction' },
//   { title: 'module.energyData.gasConsumption' },
//   { title: 'module.energyData.gasConsumer' },
// ];

export const MeterWritingErrorCodes = [
  'meterreading.validation.valueNegative',
  'meterreading.validation.newerResultAlreadySaved',
  'meterreading.validation.outerTimerange',
  'meterreading.validation.greaterThanExpected',
  'meterreading.validation.lessThanPrevReading',
  'meterreading.validation.lessThanExpected',
  'meterreading.validation.unknownRegister',
  'meterreading.validation.missingReadingOrder',
  'meterreading.validation.readingResultForMeterRegisterAlreadyExists',
  'meterreading.validation.numberDecimalPlaces',
  'meterreading.validation.lengthIntegerPart',
  'meterreading.validation.missingRegister',
];

export const ManualEntryErrorCodes = [
  'meterreading.validation.newerResultAlreadySaved',
  'meterreading.validation.missingReadingOrder',
  'meterreading.validation.readingResultForMeterRegisterAlreadyExists',
  'meterreading.validation.missingRegister',
];

export const SensorDataExcelDownloads: Record<string, string[]> = {
  SpeedSensor: ['objectName', 'sensorNumber', 'sensorAddress', 'installationDate', 'readingDataSpeed'],
  AirQualitySensor: ['building', 'sensorAddress', 'deviceID', 'installationDate', 'humidity', 'temperature', 'co2'],
  TemperatureSensor: ['building', 'sensorAddress', 'deviceID', 'installationDate', 'airTemperature', 'roadTemperature'],
  Default: ['objectType', 'sensorNumber', 'locationContext', 'sensorAddressGPS', 'installationDate'],
};

export const WarmedatenNonDownloadPermissionCodes = [Roles.administrationAreaWorker, Roles.municipalityWorker];
export const FederalStatesWithNDA = ['04', '05', '07', '09', '10', '11', '12', '13', '14', '15', '16'];

export const DefaultTranslationModule: Record<string, Record<string, string>> = {
  Warmedaten: {
    Main: 'module.warmedaten.',
    Landing: 'landing.',
    Download: 'download.',
    Request: 'request.',
    Requested: 'requested.',
  },
  SocketService: {
    Main: 'module.socketServicePage.',
  },
  DamageReport: {
    Modals: 'module.modals.damageReportV2.',
  },
  Zahlerstand: {
    Main: 'module.zahlerstand.',
  },
};

export const warmedatenServiceModule = DefaultTranslationModule.Warmedaten.Main;
export const socketServiceModule = DefaultTranslationModule.SocketService.Main;
export const damageReportV2Module = DefaultTranslationModule.DamageReport.Modals;

export const mapboxAttribution = `<a href="https://www.mapbox.com/about/maps/" style="color: #191919; padding-right: 5px" target='_blank'> © Mapbox </a>
  <a href="http://www.openstreetmap.org/copyright/" style="color: #191919; padding-right: 5px" target='_blank'> © OpenStreetMap </a>
  <strong><a href="https://apps.mapbox.com/feedback/" style="color: #191919" target='_blank'> Improve this map </a></strong>`;

export const mapboxLogoAttribution = `<a href="https://www.mapbox.com/about/maps" target='_blank'><img style="height:30px" src='./assets/images/mapbox-logo-white.png'/></a>`;

export const ExistingTeaserPermissionCodes = [
  PermissionCode.ENERGIE_MANAGEMENT_OPTIMUM,
  PermissionCode.ENERGY_GUARD,
  PermissionCode.ENERGY_MONITOR,
  PermissionCode.INNO_LIVE,
  PermissionCode.CO2_BALANCE_SHEET_LINK,
  PermissionCode.LOCAL_ELECTRICITY_MARKET_LINK,
  PermissionCode.SENSOR_DATA,
];

export const genderOptions = [
  {
    value: 'f',
    name: 'Frau',
  },
  {
    value: 'm',
    name: 'Herr',
  },
  {
    value: 'd',
    name: 'Divers',
  },
];

export const genderOptionsGemis = [
  {
    value: 'f',
    name: 'Frau',
  },
  {
    value: 'm',
    name: 'Herr',
  },
  {
    value: 'd',
    name: 'Keine Angabe',
  },
];

export const userTitles = [' ', 'Dr.', 'Prof.', 'Prof. Dr.'];

export const telephoneRegEx = `\\+?[0-9]{1}[0-9]{6,15}$`;

export const objectCategoryOrder = [
  'Öffentliche Einrichtungen',
  'Wasserbetrieb',
  'Öffentliche Beleuchtung',
  'Bildung & Sport',
  'Kein Objekttyp',
  'Wohnen',
  'Freizeiteinrichtungen',
  'Infrastruktur',
  'Verwaltung',
  'Kirche',
];

export const GRID_INFRA_CODES = new Set(['GRID_INFRA_CONSTRUCTION', 'GRID_INFRA_INVENTORY', 'GRID_INFRA_ART', 'GRID_INFRA_MAINTENANCE']);

export const GRID_INFRA_PREFIX = 'NetzInfrastruktur - ';

export const HEADER_CONTAINER = {
  EP: ['einstellungen', 'grid-infra', 'finanzreport', 'registrieren'],
  Responsive: ['instrumententafel'],
};
